import styled from 'shared/utils/styled';

import { Label } from '../PurchaseInvoice.style';

export const MonthsList = styled('ul')(() => ({
  margin: 0,
  marginBottom: 30,
  padding: 0,
  listStyle: 'none',
}));

export const MonthItem = styled('li')(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginBottom: 10,
  '&:last-child': {
    marginBottom: 0,
  },
}));

export const MonthName = styled('span')(() => ({
  fontSize: 14,
  color: '#6e6e6e',
  textTransform: 'capitalize',
}));

export const MonthAmount = styled('span')(({ theme }) => ({
  fontSize: 16,
  fontWeight: 700,
  color: '#224060',
  textAlign: 'right',
  [theme.breakpoints.down('md')]: {
    fontSize: 14,
  },
}));

export const Divider = styled('li')(() => ({
  width: '100%',
  height: 1,
  background: '#707070',
}));

export const Description = styled(Label)(() => ({
  fontSize: 14,
  color: '#6E6E6E',
}));

export const Percentage = styled('span')(({ theme }) => ({
  fontSize: 22,
  fontWeight: 700,
  textAlign: 'center',
  color: 'rgb(34, 64, 96)',
  [theme.breakpoints.down(768)]: {
    fontSize: 16,
  },
}));
